import { render, staticRenderFns } from "./MainAside.vue?vue&type=template&id=2e34cc68&scoped=true&"
import script from "./MainAside.vue?vue&type=script&lang=js&"
export * from "./MainAside.vue?vue&type=script&lang=js&"
import style0 from "./MainAside.vue?vue&type=style&index=0&id=2e34cc68&prod&scoped=true&lang=css&"
import style1 from "./MainAside.vue?vue&type=style&index=1&id=2e34cc68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e34cc68",
  null
  
)

export default component.exports